// extracted by mini-css-extract-plugin
module.exports = {"mark":"warning_mark__1rlw2","pulse-mark":"warning_pulse-mark__yxUoT"};